



































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import SessionExpiredService from "../services/appSessionExpired.service";
import appSnackbarService from "../services/appSnackbar.service";
import Axios from "axios";
import { refreshTokenApi } from "../plugins/auth-plugin/services/refreshToken.api";

@Component
export default class SessionExpiryDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Number, default: 0 }) timeout!: number;

  @Action("logout") logoutNow: any;

  showDialog = false;
  timeRemaining = 0;
  extending = false;

  @Watch("value")
  onValueChange(newVal: boolean) {
    console.log("SessionExpiryDialog: onValueChange", newVal);
    this.showDialog = newVal;
    if (newVal) {
      // Get timeRemaining from the service when dialog opens
      const serviceModel = SessionExpiredService.getModel();
      this.timeRemaining = serviceModel.timeRemaining;
    }
  }

  // @Watch("timeout")
  // onValueChangeTimeout(newVal: boolean) {
  //   console.log("SessionExpiryDialog: onValueChangeTimeout", newVal);
  //   const serviceModel = SessionExpiredService.getModel();
  //   this.timeRemaining = serviceModel.timeRemaining;
  // }

  @Watch("showDialog")
  onShowDialogChange(newVal: boolean) {
    console.log("SessionExpiryDialog: showDialog changed to", newVal);
    if (!newVal) {
      // Hide the service when dialog is closed
      SessionExpiredService.hide();
    }
  }

  async extendSession() {
    this.extending = true;
    try {
      console.log("SessionExpiryDialog: Attempting to extend session");

      // Call the backend refresh endpoint
      const response = await refreshTokenApi.refreshToken();

      if (response.data && response.data.token) {
        console.log("SessionExpiryDialog: Token refresh successful");

        // Update the token in localStorage
        localStorage.setItem("token", response.data.token);

        // Update the token in the HTTP client default headers
        Axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;

        // Update the token in vue-auth if it's being used
        if ((this as any).$auth && (this as any).$auth.setToken) {
          (this as any).$auth.setToken({ token: response.data.token });
          localStorage.removeItem("token-warning-shown");
        }

        // Close dialog and emit success
        this.showDialog = false;
        this.$emit("session-extended");

        // Show success message
        appSnackbarService.success("Session extended successfully");

        console.log("SessionExpiryDialog: Session extended successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("SessionExpiryDialog: Failed to extend session:", error);

      // Show error message to user
      if ((error as any).response && (error as any).response.status === 401) {
        appSnackbarService.error("Session expired. Please log in again.");
      } else {
        appSnackbarService.error("Failed to extend session. Please log in again.");
      }

      // If extension fails, logout
      this.logout();
    } finally {
      this.extending = false;
    }
  }

  logout() {
    this.showDialog = false;
    this.logoutNow();
  }
}
